import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { foldersKeys } from './foldersKeys';
import { EXPRESS_API } from 'configs/api/expressApi';

export enum FOLDER_ACCESS_RIGHTS {
  VIEW = 'view',
  EDIT = 'edit',
  COPY = 'copy',
}

export enum FOLDER_TYPES {
  PERSONAL = 'personal',
  DEFAULT = 'default',
  SHARED = 'shared',
}

export enum FOLDER_ACCESS_MANAGER {
  NONE = 'none',
  SELF = 'self',
  ADMIN = 'admin',
}

export type FoldersV2 = {
  folderId: string | number;
  name: string;
  userId?: number;
  sharedBy?: string;
  isDefaultFolders?: boolean;
  access?: FOLDER_ACCESS_RIGHTS;
  isDeletable: boolean;
  folderType: FOLDER_TYPES;
  accessManager?: FOLDER_ACCESS_MANAGER;
  folderSharedAs?: string;
  isAIFolder?: boolean;
};

export type GetFolderParams = {
  getShared: boolean;
  refetchOnMount?: 'always' | boolean;
};

type GroupedFolderResponse = {
  folders: Record<string, FoldersV2[]>;
};

const getSharedFolders = async (
  params: GetFolderParams
): Promise<GroupedFolderResponse> => {
  return (await EXPRESS_API.get(`folders/grouped`, { params })).data;
};

export const useGetFoldersV2 = ({
  params,
  options,
}: {
  params: GetFolderParams;
  options?: Omit<
    UseQueryOptions<
      GroupedFolderResponse,
      Error,
      GroupedFolderResponse,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >;
}) => {
  return useQuery(
    foldersKeys.grouped(params.getShared),
    () => getSharedFolders(params),
    options ?? undefined
  );
};
